
export const siteVersion = {
  major: 0,
  minor: 1,
  revision: 27,
  label: `0.1.27`,
};